import { Error } from "@focus/focusUI";

interface Props {
  path: string;
}

export function DocumentViewer({ path }: Props) {
  const isPdf = path.includes("/pdf/");

  if (isPdf) {
    return (
      <embed
        role="embed"
        src={path}
        type="application/pdf"
        className="flex-1 w-full h-100"
      />
    );
  }

  return (
    <iframe
      role="iframe"
      className="flex-1 border-none m-0 p-0 overflow-hidden h-100"
      sandbox="allow-scripts allow-forms allow-presentation allow-same-origin"
      src={path}
    >
      <Error message={"Unable to load " + path} size={50} />
    </iframe>
  );
}
